import React, { useEffect, useState } from 'react';
import { Accessibility, Type, Link as LinkIcon, TypeOutline, RotateCcw, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function AccessibilityWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [largeText, setLargeText] = useState(false);
  const [highlightLinks, setHighlightLinks] = useState(false);
  const [readableFont, setReadableFont] = useState(false);
  useEffect(() => {
    if (largeText) document.body.classList.add('a11y-large-text');else document.body.classList.remove('a11y-large-text');
    if (highlightLinks) document.body.classList.add('a11y-highlight-links');else document.body.classList.remove('a11y-highlight-links');
    if (readableFont) document.body.classList.add('a11y-readable-font');else document.body.classList.remove('a11y-readable-font');
  }, [largeText, highlightLinks, readableFont]);
  const reset = () => {
    setLargeText(false);
    setHighlightLinks(false);
    setReadableFont(false);
  };
  return <div className="fixed bottom-6 right-6 z-[100]" data-id="element-25">
      <AnimatePresence data-id="element-26">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} className="absolute bottom-16 right-0 w-72 bg-white rounded-2xl shadow-2xl border border-slate-100 overflow-hidden" data-id="element-27">
            <div className="bg-[#225274] text-white p-4 flex justify-between items-center" data-id="element-28">
              <h3 className="font-bold flex items-center gap-2" data-id="element-29">
                <Accessibility size={18} data-id="element-30" />
                Accessibility Menu
              </h3>
              <button onClick={() => setIsOpen(false)} className="hover:bg-white/20 p-1 rounded-full transition-colors" aria-label="Close Accessibility Menu" data-id="element-31">
                <X size={18} data-id="element-32" />
              </button>
            </div>
            <div className="p-4 space-y-2" data-id="element-33">
              <button onClick={() => setLargeText(!largeText)} className={`w-full flex items-center gap-3 p-3 rounded-lg border transition-colors ${largeText ? 'bg-[#cef4d2]/50 border-[#54c595] text-[#225274]' : 'border-slate-100 hover:bg-slate-50 text-slate-700'}`} aria-pressed={largeText} data-id="element-34">
                <Type size={18} className={largeText ? 'text-[#54c595]' : ''} data-id="element-35" />
                <span className="font-medium text-sm" data-id="element-36">Larger Text</span>
              </button>

              <button onClick={() => setHighlightLinks(!highlightLinks)} className={`w-full flex items-center gap-3 p-3 rounded-lg border transition-colors ${highlightLinks ? 'bg-[#cef4d2]/50 border-[#54c595] text-[#225274]' : 'border-slate-100 hover:bg-slate-50 text-slate-700'}`} aria-pressed={highlightLinks} data-id="element-37">
                <LinkIcon size={18} className={highlightLinks ? 'text-[#54c595]' : ''} data-id="element-38" />
                <span className="font-medium text-sm" data-id="element-39">Highlight Links</span>
              </button>

              <button onClick={() => setReadableFont(!readableFont)} className={`w-full flex items-center gap-3 p-3 rounded-lg border transition-colors ${readableFont ? 'bg-[#cef4d2]/50 border-[#54c595] text-[#225274]' : 'border-slate-100 hover:bg-slate-50 text-slate-700'}`} aria-pressed={readableFont} data-id="element-40">
                <TypeOutline size={18} className={readableFont ? 'text-[#54c595]' : ''} data-id="element-41" />
                <span className="font-medium text-sm" data-id="element-42">Readable Font</span>
              </button>
            </div>
            <div className="p-4 bg-slate-50 border-t border-slate-100" data-id="element-43">
              <button onClick={reset} className="w-full flex items-center justify-center gap-2 py-2 text-sm font-bold text-[#54c595] hover:text-[#4bafbc] transition-colors" data-id="element-44">
                <RotateCcw size={16} data-id="element-45" />
                Reset Settings
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>

      <button onClick={() => setIsOpen(!isOpen)} className="bg-gradient-to-r from-[#225274] via-[#4bafbc] to-[#54c595] hover:brightness-110 text-white p-4 rounded-full shadow-xl hover:shadow-2xl transition-all flex items-center justify-center" aria-label="Toggle Accessibility Menu" data-id="element-46">
        <Accessibility size={28} data-id="element-47" />
      </button>
    </div>;
}